import { extendVariants, Input as InputNext } from "@nextui-org/react";
import { useFormContext } from 'react-hook-form';

const InputVariant = extendVariants(InputNext, {
  variants: {
    size: {
      md: {
        inputWrapper: [
          'h-12'
        ],
        input: [
          'text-base'
        ],
        label: [
          'text-base'
        ]
      }
    },
    color: {
      default: { // <- add a new color variant
        inputWrapper: [ // <- Input wrapper slot
          "bg-white",
          "border border-gray-500",
          "rounded-lg",
          "shadow-none",
          "transition-colors",
          "focus-within:bg-white",
          "data-[hover=true]:border-gray-500",
          "data-[hover=true]:bg-white",
          "group-data-[focus=true]:bg-white border-gray-500",
          "group-data-[invalid=true]:border-red-400"
        ],
        input: [  // <- Input element slot
          "text-gray-800",
          "placeholder:text-gray-500",
        ],
      },
      custom: { // <- add a new color variant
        inputWrapper: [ // <- Input wrapper slot
          "bg-white",
          "border-b border-primary rounded-none",
          "shadow-none",
          "transition-colors",
          "focus-within:bg-white",
          "data-[editable=true]:text-gray-800 text-base font-semibold",
          "data-[placeholder=true]:text-gray-800 text-base font-semibold",
          "data-[hover=true]:border-primary",
          "data-[hover=true]:bg-white",
          "group-data-[focus=true]:bg-white border-primary",
        ],
        label: [
          "text-primary font-semibold"
        ],
        input: [  // <- Input element slot
          "text-gray-800 font-semibold",
          "placeholder:text-gray-500",
        ],
      },
      customDanger: { // <- add a new color variant
        inputWrapper: [ // <- Input wrapper slot
          "bg-white",
          "border-b border-danger rounded-none",
          "shadow-none",
          "transition-colors",
          "focus-within:bg-white",
          "data-[editable=true]:text-gray-800 text-base font-semibold",
          "data-[placeholder=true]:text-gray-800 text-base font-semibold",
          "data-[hover=true]:border-primary",
          "data-[hover=true]:bg-white",
          "group-data-[focus=true]:bg-white border-danger",
        ],
        label: [
          "text-primary font-semibold text-base"
        ],
        input: [  // <- Input element slot
          "text-gray-800 text-sm font-semibold",
          "placeholder:text-gray-500",
        ],
      },
    },
  },
  defaultVariants: { // <- modify/add default variants
    color: "default",
    size: 'md',
    radius: 'sm',
  },
});

const Input = props => {
  const { name, label = '', showLabel = false, className = '', classNames = {}, ...rest } = props;
  const { register } = useFormContext()
  return (
    <InputVariant
      {...register(name)} 
      {...rest}
      label={showLabel ? label : null}
      size='md'
      className={className}
      classNames={{
        base: 'w-full',
        inputWrapper: 'w-full',
        ...classNames,
      }}
    />
  );
};


export default Input;
